__turbopack_context__.v({
  "changeLink": "Timeline-module-scss-module__zxlnUa__changeLink",
  "changesUl": "Timeline-module-scss-module__zxlnUa__changesUl",
  "content": "Timeline-module-scss-module__zxlnUa__content",
  "externalLink": "Timeline-module-scss-module__zxlnUa__externalLink",
  "left": "Timeline-module-scss-module__zxlnUa__left",
  "linkIcon": "Timeline-module-scss-module__zxlnUa__linkIcon",
  "right": "Timeline-module-scss-module__zxlnUa__right",
  "timeline": "Timeline-module-scss-module__zxlnUa__timeline",
  "timelineContainer": "Timeline-module-scss-module__zxlnUa__timelineContainer",
  "timelineMediaImage": "Timeline-module-scss-module__zxlnUa__timelineMediaImage",
  "timelineTable": "Timeline-module-scss-module__zxlnUa__timelineTable",
  "timelineTableScrollContainer": "Timeline-module-scss-module__zxlnUa__timelineTableScrollContainer",
});
